import React from 'react'
import { AppRunProgress } from '@components'
import { Box } from '@mui/material'
import { globalExecutionsTableReportCellData } from 'Pages/Admin/GlobalExecution/@signals'
import { reportSearchesModalId } from '@signals'

export default function progressBarColumn() {
	return [{
		name: 'id_last_execution', label: 'Status',
		options: {
			display: 'excluded',
		},
	}, {
		name: 'id_last_execution',
		label: 'Status',
		options: {
			filter: false,
			customBodyRowRenderLite: (idReport, row) => <ProgressBar idReport={idReport} row={row}/>,
		},
	}]
}

function ProgressBar({ idReport, row }) {
	const rowData = { ...row, ...globalExecutionsTableReportCellData.value[idReport] }
	return <Box sx={{ display: 'flex', justifyContent: 'center', width: 1 }}>
		<AppRunProgress
			label={!rowData?.generating && 'Running'}
			actual={rowData?.percentage}
			total={100}
			done={rowData?.completeTasksString}
			totalText={rowData?.totalTasksString}
			generating={rowData?.generating}
			onClick={() => {
				if (!rowData?.generating) {
					reportSearchesModalId.value = idReport
				}
			}}
		/>
	</Box>
}
